// This file is based on the zenreg password input component
// REF: src/global/client/components/atoms/Inputs/Password

import {
  ERROR_MESSAGE_IDS,
  PASSWORD_LENGTH_VALIDATION,
  PASSWORD_LOWERCASE_VALIDATION,
  PASSWORD_MAX_LENGTH,
  PASSWORD_MIN_LENGTH,
  PASSWORD_NUMBER_VALIDATION,
  PASSWORD_SYMBOL_VALIDATION,
  PASSWORD_UPPERCASE_VALIDATION,
  VALIDATIONS
} from '../constants';

const REGEXPS = {
  lowercase: /[a-z]+/,
  number: /[0-9]+/,
  symbol: /[^\p{L}\d\s]/u,
  uppercase: /[A-Z]+/
};

/**
 * Evaluates password validations.
 *
 * @param {string} value - Password value to check
 * @returns {Array} Validations passed
 */
function evaluatePasswordValidations(value = '') {
  const validationsPassed = [];

  if (value.length >= PASSWORD_MIN_LENGTH && value.length <= PASSWORD_MAX_LENGTH) {
    validationsPassed.push(PASSWORD_LENGTH_VALIDATION);
  }
  if (REGEXPS.lowercase.test(value)) {
    validationsPassed.push(PASSWORD_LOWERCASE_VALIDATION);
  }
  if (REGEXPS.number.test(value)) {
    validationsPassed.push(PASSWORD_NUMBER_VALIDATION);
  }
  if (REGEXPS.symbol.test(value)) {
    validationsPassed.push(PASSWORD_SYMBOL_VALIDATION);
  }
  if (REGEXPS.uppercase.test(value)) {
    validationsPassed.push(PASSWORD_UPPERCASE_VALIDATION);
  }

  return validationsPassed;
}

/**
 * Checks if password is valid according to all validation criteria.
 *
 * @param {string} value - Password value to check
 * @returns {boolean} Whether the password is valid
 */
export function isPasswordValid(value = '') {
  const validationsPassed = evaluatePasswordValidations(value);
  return validationsPassed.length === VALIDATIONS.length;
}

/**
 * Gets the first failed validation error message ID
 *
 * @param {string} value - Password value to check
 * @returns {string|null} Error message ID if invalid, null if valid
 */
export function getPasswordErrorMessageId(value = '') {
  if (isPasswordValid(value)) {
    return null;
  }

  const validationsPassed = evaluatePasswordValidations(value);

  return ERROR_MESSAGE_IDS[
    VALIDATIONS.find((validation) => !validationsPassed.includes(validation))
  ];
}

/**
 * Maps validation status to a boolean value.
 *
 * @param {string} value - Password value to check
 * @returns {object} Validation status
 */
export function mapValidationsStatus(value = '') {
  const validationsPassed = evaluatePasswordValidations(value);

  return VALIDATIONS.reduce((acc, validation) => {
    acc[validation] = validationsPassed.includes(validation);
    return acc;
  }, {});
}
